import React from 'react';

import { TextDivider } from '@planne-software/uni/v2';
import { useTranslate } from '@src/core/hooks';

export const AuthMethodDivider = () => {
  const { i18n } = useTranslate();

  return <TextDivider data-testid='auth-method-divider'>{i18n('checkout_auth_or_divider')}</TextDivider>;
};

export default AuthMethodDivider;
